import mediumZoom, { Zoom } from "medium-zoom"

let zoom: Zoom
export const setZoomableImages = (): void => {
  const query =
    "img.gatsby-resp-image-image, .gatsby-resp-image-image img"

  const timer = setTimeout(() => {
    if (zoom) {
      zoom.detach()
    }

    zoom = mediumZoom(query, {
      margin: 20,
      get background() {
        return getComputedStyle(document.documentElement).getPropertyValue("--bg").trim()
      },
    })

    clearTimeout(timer)
  }, 500)
}
